import { LoadingState } from "../../Common";
import { WorkflowOptions } from "../Models/WorkflowOptions";
import {
  WorkflowOptionsAction,
  WorkflowOptionsActionType,
  IWorkflowOptionsLoadedPayload,
  ISetWorkflowOptionsErroredPayload
} from "../Actions/WorkflowOptionActions";

export interface WorkflowOptionsState {
  options?: WorkflowOptions;
  loadingState: LoadingState;
  errorMessage: string;
  errorCode?: number;
}

const initialWorkflowOptionsState: WorkflowOptionsState = {
  loadingState: {
    isLoaded: false,
    isLoading: false,
    errored: false
  },
  errorMessage: ""
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

const workflowOptionsReducer = (
  workflowOptionsState: WorkflowOptionsState = initialWorkflowOptionsState,
  action: WorkflowOptionsAction
) => {
  switch (action.type) {
    case WorkflowOptionsActionType.WORKFLOW_OPTIONS_LOADED: {
      const payload = <IWorkflowOptionsLoadedPayload>action.payload;

      const { loadedOptions } = payload;

      return updateObject(workflowOptionsState, {
        options: loadedOptions,
        loadingState: {
          isLoaded: true,
          isLoading: false,
          errored: false
        }
      });
    }
    case WorkflowOptionsActionType.WORKFLOW_OPTIONS_SET_LOADING: {
      return updateObject(workflowOptionsState, {
        options: undefined,
        loadingState: {
          isLoaded: false,
          isLoading: true,
          errored: false
        }
      });
    }
    case WorkflowOptionsActionType.WORKFLOW_OPTIONS_SET_ERRORED: {
      const payload = <ISetWorkflowOptionsErroredPayload>action.payload;
      return updateObject(workflowOptionsState, {
        options: undefined,
        loadingState: {
          isLoaded: false,
          isLoading: false,
          errored: true
        },
        errorMessage: payload.errorMessage,
        errorCode: payload.errorCode
      });
    }
    default:
      return workflowOptionsState;
  }
};

export default workflowOptionsReducer;
